export default __webpack_public_path__ + "static/LogoMoMa (1)-9bcb51bb53261a63f6560b644e2bde94.jpg";